/**
 * Shared transforms for flattening Order[] into EnhancedOrderBoxWithContext[].
 *
 * Used by Incoming and Dispatch pages to convert API order responses
 * into flat box lists with order context fields attached.
 */

import { Order, EnhancedOrderBoxWithContext, BoxStatusCode } from '../types/logistics';
import { transformOrderBoxToEnhanced } from '../hooks/use-logistics-api';

/**
 * Flattens orders into a flat list of enhanced boxes with order context,
 * filtered to only include boxes matching the given status codes.
 */
export function flattenOrdersToBoxes(
  orders: Order[],
  statusFilter: BoxStatusCode[]
): EnhancedOrderBoxWithContext[] {
  const boxes: EnhancedOrderBoxWithContext[] = [];
  orders.forEach(order => {
    const enhanced = order.orderBoxes.map(ob => ({
      ...transformOrderBoxToEnhanced(ob),
      assignedDriverId: order.assignedDriverId,
      collectionDriverId: order.collectionDriverId ?? order.assignedDriverId,
      deliveryDriverId: order.deliveryDriverId ?? null,
      assignedPartnerId: order.assignedPartnerId,
      collectionDate: order.collectionDate,
      deliveryDate: order.deliveryDate ?? null,
      customerName: order.customer
        ? `${order.customer.firstName} ${order.customer.lastName}`
        : null,
    } as EnhancedOrderBoxWithContext));
    boxes.push(...enhanced.filter(b => statusFilter.includes(b.statusCode)));
  });
  return boxes;
}
